(function () {
  'use strict';

  var articleBody = document.querySelector('.iurop-advice-article__rte');
  if (articleBody && document.createTreeWalker) {
    var walker = document.createTreeWalker(articleBody, NodeFilter.SHOW_TEXT);
    var textNode;
    while ((textNode = walker.nextNode())) {
      textNode.nodeValue = textNode.nodeValue.replace(/[\u2600-\u27BF\u{1F300}-\u{1FAFF}]\uFE0F?/gu, '');
    }
  }

  var articleRoot = articleBody && articleBody.closest('[data-advice-article-handle]');
  var articleHandle = articleRoot && articleRoot.getAttribute('data-advice-article-handle');
  if (articleBody && articleHandle && articleHandle.indexOf('consejos-para-alcanzar-tu-peso-ideal-comiendo-equilibradamente') !== -1) {
    var paragraphs = Array.prototype.slice.call(articleBody.children).filter(function (element) {
      return element.tagName === 'P' && element.querySelectorAll('span').length >= 17;
    });
    var tipsParagraph = paragraphs[0];

    if (tipsParagraph) {
      var sourceSpans = Array.prototype.slice.call(tipsParagraph.querySelectorAll('span'));
      var tipGroups = [[1, 2], [3, 4], [5, 6], [7, 8], [9, 10]];
      var fragment = document.createDocumentFragment();

      var appendBreak = function () {
        fragment.appendChild(document.createElement('br'));
      };
      var appendSpan = function (index, className) {
        var span = sourceSpans[index] && sourceSpans[index].cloneNode(true);
        if (!span) return;
        if (className) span.classList.add(className);
        fragment.appendChild(span);
      };

      appendSpan(0);
      appendBreak();
      appendBreak();

      tipGroups.forEach(function (group, index) {
        appendSpan(group[0], 'iurop-advice-article__tip-heading');
        appendBreak();
        appendSpan(group[1]);
        appendBreak();
        if (index < tipGroups.length - 1) appendBreak();
      });

      appendBreak();
      appendSpan(16);
      tipsParagraph.replaceChildren(fragment);
    }
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-advice-product-form]');
    if (!form || !window.fetch) return;

    event.preventDefault();
    var button = form.querySelector('button[type="submit"]');
    var status = form.querySelector('[data-advice-product-status]');
    if (!button || button.disabled) return;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().catch(function () { return {}; }).then(function (payload) {
            throw new Error(payload.description || payload.message || form.getAttribute('data-error-message'));
          });
        }
        return response.json();
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:updated'));
      })
      .catch(function (error) {
        if (status) status.textContent = error.message;
      })
      .then(function () {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      });
  });
}());
